import { useState } from 'react';
import axios from 'axios';
import { Eraser, ShieldAlert } from 'lucide-react';
import { toast } from 'sonner';
import { API } from '../lib/format';

const SCOPES = [
  ['movements', 'Cari hareketleri sil ve bakiyeleri sıfırla', 'Cari kartları kalır; ekstreler boşalır'],
  ['checks', 'Tüm çekleri sil', 'Portföy ve vade takvimi boşalır'],
  ['transactions', 'Tüm gelir/gider işlemlerini sil', 'Dashboard ve nakit akış raporu sıfırlanır'],
  ['contacts', 'Cari kartlarını da sil', 'Dikkat: tüm müşteri/tedarikçi kartları ve hareketleri kalıcı silinir'],
];

export function DataReset({ onDone }) {
  const [scopes, setScopes] = useState(['movements']);
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const toggle = (k) => setScopes((s) => (s.includes(k) ? s.filter((x) => x !== k) : [...s, k]));
  const submit = async (e) => {
    e.preventDefault(); setError('');
    if (!scopes.length) return setError('En az bir seçim yapın');
    if (!window.confirm('Seçilen veriler kalıcı olarak silinecek. Bu işlem geri alınamaz. Devam edilsin mi?')) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/reset`, { password, scopes });
      const parts = [data.movements != null && `${data.movements} hareket`, data.checks != null && `${data.checks} çek`, data.transactions != null && `${data.transactions} işlem`, data.contacts != null && `${data.contacts} cari`].filter(Boolean);
      toast.success('Veriler temizlendi', { description: parts.join(' · ') + (data.balances_reset != null ? ` · ${data.balances_reset} bakiye sıfırlandı` : '') });
      setPassword(''); onDone();
    } catch (err) { setError(typeof err.response?.data?.detail === 'string' ? err.response.data.detail : 'İşlem başarısız'); }
    finally { setBusy(false); }
  };
  return <div className="panel form-card check-form danger-panel" style={{ marginTop: 18 }} data-testid="data-reset-panel">
    <div className="panel-head"><div><p className="eyebrow">VERİ TEMİZLİĞİ</p><h2>Verileri sıfırla</h2></div><ShieldAlert size={22} color="#cf625b" /></div>
    <p className="rate-hint">Excel'den yeniden yüklemeden önce eski verileri temizlemek için kullanın. Canlı (yayındaki) sürümde de aynı şekilde çalışır.</p>
    <form onSubmit={submit}>
      <div className="scope-list">{SCOPES.map(([k, label, hint]) => <label key={k} className={`scope ${scopes.includes(k) ? 'on' : ''} ${k === 'contacts' ? 'warn' : ''}`} data-testid={`reset-scope-${k}`}><input type="checkbox" checked={scopes.includes(k)} onChange={() => toggle(k)} /><div><b>{label}</b><small>{hint}</small></div></label>)}</div>
      <label>Onay için giriş şifreniz<input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" /></label>
      {error && <p className="error-text" data-testid="reset-error">{error}</p>}
      <button className="primary danger-button" disabled={busy} data-testid="reset-submit-button"><Eraser size={15} /> {busy ? 'Siliniyor…' : 'Seçilenleri kalıcı olarak sil'}</button>
    </form>
  </div>;
}
